import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    userList: [],
    code: [],
    pidType: [],
    pidCheck: false,
    submitCategory: [],
    submitCateCheck: false
  },
  actions: {
    async getUserList ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_ALL_USER_PARMAS,
          id: store.state.authentication.requestId
        })
        state.userList = res.data.message
        return res.data
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async updateUserRole ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.UPDATE_USER_ROLE_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return res.data
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async updateUserNickname ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.UPDATE_USER_NICKNAME_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return res.data
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async updatePw ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.UPDATE_USER_PW_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return res.data
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async getSystemCode ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_SYSTEM_PARAMS,
          id: store.state.authentication.requestId
        })
        // state.systemcode = res.data.message
        // db에 추가하면 백엔드 오류나서 roomservice, amenity, taxi 외에는 프론트에서 추가함(백엔드에서 수정안해줌)
        // 여기서 추가한 시스템코드는 뷰어 store/system.js에도 똑같이 추가해줘야함
        const expressCheckin = {
          id: 'system_express_checkin',
          label: 'Express Checkin',
          type: 'system'
        }
        const checkout = {
          id: 'system_checkout',
          label: 'Checkout',
          type: 'system'
        }
        const survey = {
          id: 'system_survey',
          label: 'Survey',
          type: 'system'
        }
        const mobility = {
          id: 'system_mobility',
          label: 'Mobility',
          type: 'system'
        }
        const shop = {
          id: 'system_shop_service',
          label: 'Shop',
          type: 'system'
        }
        const others = [
          // expressCheckin,
          // checkout,
          // survey,
          // mobility
        ]
        const systemCode = [
          'system_room_service',
          'system_express_checkin',
          'system_checkout',
          'system_mobility',
          'system_shop_service'
        ]
        const codeData = res.data.message.map(x => {
          return {
            id: x.name,
            label: x.desc,
            type: 'system'
          }
        }).filter(x => systemCode.includes(x.id))
        const array = res.data && res.data.message ? codeData : []
        return array
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getUserCode ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_SERVICE_PARAMS,
          id: store.state.authentication.requestId
        })
        const codeData = res.data.message.map(x => {
          return {
            id: x.id,
            label: x.label,
            type: x.type
          }
        })
        return res.data.message ? codeData : []
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getCodes ({ state, dispatch }) {
      const res = await Promise.all([
        dispatch('getSystemCode'),
        dispatch('getUserCode')
      ])
      if (res && res.length) {
        const systemCode = res[0] || []
        const userCode = res[1] || []
        state.code = systemCode.concat(userCode)
      }
      return res
    },
    async setCode ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_SERVICE_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return res
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getSubmitCategory ({ state, dispatch }) {
      return dispatch('getSubmitCategoryFile').then((res) => {
        if (res.message && res.message.includes('No file')) {
          const defaultData = {
            list: [],
            requiredEdit: false
          }
          dispatch('setSubmitCategory', defaultData).then(() => {
            dispatch('getSubmitCategoryFile')
          })
        } else {
          return res
        }
      })
    },
    async getSubmitCategoryFile ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'setting/submit_category.json'
        })
        if (res) {
          state.submitCategory = res.data.message.list && res.data.message.list.length
            ? [{ id: '#none', label: '#none' }].concat(res.data.message.list)
            : [{ id: '#none', label: '#none' }]
          state.submitCateCheck = res.data.message.list.length > 0 && res.data.message.requiredEdit
        }
        return res.data.message
      } catch (ex) {
        // console.error('error:', ex)
        // alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async setSubmitCategory ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'setting/submit_category.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async getPidType ({ state, dispatch }) {
      return dispatch('getPidTypeFile').then((res) => {
        if (res.message && res.message.includes('No file')) {
          const defaultData = {
            list: [],
            requiredEdit: false
          }
          dispatch('setPidType', defaultData).then(() => {
            dispatch('getPidTypeFile')
          })
        } else {
          return res
        }
      })
    },
    async getPidTypeFile ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'setting/pid_type.json'
        })
        if (res) {
          state.pidType = [{ id: '#none', label: '#none' }].concat(res.data.message.list)
          state.pidCheck = res.data.message.requiredEdit
        }
        return res.data.message
      } catch (ex) {
        // console.error('error:', ex)
        // alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async setPidType ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'setting/pid_type.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    userList (state) {
      return state.userList
    },
    codeList: state => { // 일반 전송코드
      return state.code
    },
    submitCodeList: state => { // 일반 전송코드
      const excludePattern = /SHOP_ITEM_TYPE/i // 일반 전송코드에서 제외할 type
      return state.code && state.code.filter(x => !excludePattern.test(x.type))
    },
    shopCodeList: state => { // 샵 전용 전송코드
      return state.code && state.code.filter(x => x.id.includes('system_shop_service') || x.type.includes('SHOP_ITEM_TYPE'))
    },
    pIdType: state => state.pidType
  }
}
